module.exports = __webpack_public_path__ + "media/images/flags/cz-4920f11288fe2e5698bf0db1b6457385.svg";